
import Confetti from "react-confetti";
import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
const chapterQuestions = {
    "Chapter 1": [
        {
          question: "What is the primary goal of scientific misconduct prevention?",
          options: [
            "To maximize research outcomes",
            "To protect participants' rights and well-being",
            "To reduce research costs",
            "To promote data falsification",
          ],
          correctAnswer: 1,
        },
        {
          question:
            "Which document serves as a guideline for ethical behavior in human research?",
          options: [
            "The Nuremberg Code",
            "The Helsinki Declaration",
            "The Belmont Report",
            "The Declaration of Geneva",
          ],
          correctAnswer: 1,
        },
        {
          question:
            "Which concept is central to ensuring informed consent in research?",
          options: [
            "Voluntary participation",
            "Public funding",
            "Pseudonymization of data",
            "Maximizing researcher benefits",
          ],
          correctAnswer: 0,
        },
        {
          question: "What is an example of data falsification in research?",
          options: [
            "Withholding irrelevant data",
            "Manipulating images or data results",
            "Reporting findings based on ethical guidelines",
            "Discussing findings with colleagues",
          ],
          correctAnswer: 1,
        },
        {
          question:
            "Which of the following is NOT an ethical principle for research involving human participants?",
          options: [
            "Respect for persons",
            "Beneficence",
            "Justice",
            "Deception as a research tool",
          ],
          correctAnswer: 3,
        },
      ],
    "Chapter 2": [
        {
          question:
            "Which historical event is mentioned as an example of scientific misconduct that influenced research ethics?",
          options: [
            "The Nuremberg Code",
            "The Helsinki Declaration",
            "Unethical experiments during Nazi Germany",
            "The Belmont Report",
          ],
          correctAnswer: 2,
        },
        {
          question:
            "Which of the following is a key principle of research ethics mentioned in Chapter 2?",
          options: [
            "Social and clinical value",
            "Profit maximization",
            "Selective data reporting",
            "Rapid data collection",
          ],
          correctAnswer: 0,
        },
        {
          question:
            "What is essential to obtain from research participants to ensure ethical research?",
          options: [
            "Informed consent",
            "Financial compensation",
            "Verbal agreement only",
            "Immediate participation",
          ],
          correctAnswer: 0,
        },
        {
          question: "Which behavior is considered research misconduct?",
          options: [
            "Ensuring confidentiality",
            "Falsification of data",
            "Following ethical guidelines",
            "Collecting informed consent",
          ],
          correctAnswer: 1,
        },
        {
          question:
            "Which of the following is NOT listed as a principle of research ethics in Chapter 2?",
          options: [
            "Confidentiality",
            "Accountability",
            "Social and clinical value",
            "Profit maximization",
          ],
          correctAnswer: 3,
        },
      ],
    "Chapter 3": [
        {
          question:
            "Which type of research involves collecting information without interfering with the setting?",
          options: [
            "Observational research",
            "Experimental research",
            "Intervention research",
            "Survey research",
          ],
          correctAnswer: 0,
        },
        {
          question: "What is the key feature of experimental research?",
          options: [
            "Collecting data without intervention",
            "Comparing an experimental group with a control group",
            "Observing natural behavior in the community",
            "Conducting research without any planning",
          ],
          correctAnswer: 1,
        },
        {
          question:
            "The handwashing case study in Chapter 3 is an example of which research type?",
          options: [
            "Experimental research",
            "Intervention research",
            "Observational research",
            "Survey research",
          ],
          correctAnswer: 2,
        },
        {
          question:
            "Why is it important to keep conditions the same between the experimental and control groups?",
          options: [
            "To confuse the participants",
            "To ensure that any differences are due to the treatment",
            "To make the study easier to conduct",
            "To eliminate the need for a control group",
          ],
          correctAnswer: 1,
        },
        {
          question:
            "Which research type involves making deliberate changes and comparing outcomes with a group that does not receive the change?",
          options: [
            "Observational research",
            "Experimental research",
            "Descriptive research",
            "Historical research",
          ],
          correctAnswer: 1,
        },
      ],
    "Chapter 4": [
        {
          question: "What is the first step in the research cycle as described in Chapter 4?",
          options: [
            "Describing the problem in detail",
            "Identifying a problem",
            "Reviewing existing information",
            "Narrowing down the research question",
          ],
          correctAnswer: 1,
        },
        {
          question: "What does carrying out a literature review involve?",
          options: [
            "Collecting new data from experiments",
            "Reviewing journals, reports, policies, and guidelines",
            "Implementing a solution immediately",
            "Designing new research methods",
          ],
          correctAnswer: 1,
        },
        {
          question: "Once a problem is identified, what is the next key step?",
          options: [
            "Describing the problem in detail",
            "Identifying potential reasons for the problem",
            "Collecting data through experiments",
            "Testing an intervention immediately",
          ],
          correctAnswer: 0,
        },
        {
          question: "Why is it important to identify potential causes of the problem?",
          options: [
            "To create a more general research question",
            "To fully understand the factors contributing to the problem",
            "To skip the literature review",
            "To design an intervention without data",
          ],
          correctAnswer: 1,
        },
        {
          question: "What does narrowing down your research question help you to do?",
          options: [
            "Address the entire problem at once",
            "Focus on a manageable aspect of the problem",
            "Avoid looking at available information",
            "Implement solutions without further study",
          ],
          correctAnswer: 1,
        },
      ],
    "Chapter 5": [
        {
          question: "What is the primary goal of scientific misconduct prevention?",
          options: [
            "To maximize research outcomes",
            "To protect participants' rights and well-being",
            "To reduce research costs",
            "To promote data falsification",
          ],
          correctAnswer: 1,
        },
        {
          question:
            "Which document serves as a guideline for ethical behavior in human research?",
          options: [
            "The Nuremberg Code",
            "The Helsinki Declaration",
            "The Belmont Report",
            "The Declaration of Geneva",
          ],
          correctAnswer: 1,
        },
        {
          question:
            "Which concept is central to ensuring informed consent in research?",
          options: [
            "Voluntary participation",
            "Public funding",
            "Pseudonymization of data",
            "Maximizing researcher benefits",
          ],
          correctAnswer: 0,
        },
        {
          question: "What is an example of data falsification in research?",
          options: [
            "Withholding irrelevant data",
            "Manipulating images or data results",
            "Reporting findings based on ethical guidelines",
            "Discussing findings with colleagues",
          ],
          correctAnswer: 1,
        },
        {
          question:
            "Which of the following is NOT an ethical principle for research involving human participants?",
          options: [
            "Respect for persons",
            "Beneficence",
            "Justice",
            "Deception as a research tool",
          ],
          correctAnswer: 3,
        },
      ],
    "Chapter 7": [
        {
          question: "What is the primary purpose of dissemination in research?",
          options: [
            "To collect data for future research",
            "To share research findings with others",
            "To evaluate healthcare workers’ performance",
            "To publish in academic journals",
          ],
          correctAnswer: 1,
        },
        {
          question: "Who should be involved in the dissemination of research findings?",
          options: [
            "Only the lead researcher",
            "The Community Health Extension Worker and community members",
            "Only healthcare workers",
            "Only local government officials",
          ],
          correctAnswer: 1,
        },
        {
          question: "What is one of the best ways to engage the community when disseminating research findings?",
          options: [
            "Sending emails to healthcare workers",
            "Organizing community meetings",
            "Posting research findings on social media only",
            "Keeping the findings confidential",
          ],
          correctAnswer: 1,
        },
        {
          question: "Why is collaboration between healthcare facilities important for dissemination?",
          options: [
            "It allows for better resource sharing",
            "It helps one facility dominate others",
            "It reduces the need for research",
            "It ensures only one facility benefits from the findings",
          ],
          correctAnswer: 0,
        },
        {
          question: "What is the role of the Community Health Officer (CHO) in dissemination?",
          options: [
            "Approving and supporting the research project",
            "Keeping the findings confidential",
            "Limiting dissemination to only healthcare workers",
            "Preventing collaboration between healthcare facilities",
          ],
          correctAnswer: 0,
        },
      ],
  };


  const questionVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -50 },
  };
const QuizPopup = ({ chapter, onClose , onComplete}) => {


  const [showConfetti, setShowConfetti] = useState(false);

  const questions = chapterQuestions[chapter] || [];
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [showCorrections, setShowCorrections] = useState(false);
//   const [showQuiz, setShowQuiz] = useState(true);

//   const handleClose = () => {
//     // Close the quiz modal (You can set state or call a function here)
//     setShowQuiz(false); // Example: Assuming `setShowQuiz` controls visibility
//   };

  const handleNext = (skip = false) => {
    setAnswers((prev) => [...prev, skip ? null : Number(selectedOption)]);
    setSelectedOption(null);

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion((prev) => prev + 1);
    } else {
      setShowResults(true);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion((prev) => prev - 1);
      setAnswers((prev) => prev.slice(0, -1)); // Remove the last answer
    }
  };

  const calculateScore = () => {
    const correctCount = answers.reduce((acc, answer, index) => {
        return answer === questions[index].correctAnswer ? acc + 1 : acc;
      }, 0);
      return ((correctCount / questions.length) * 100).toFixed(0);  };
      const score = calculateScore();
      const isPerfectScore = score === "100"; // Check if 100%
     
      useEffect(() => {
        if (isPerfectScore) {
          setShowConfetti(true);
          setTimeout(() => setShowConfetti(false), 5000); // Stop confetti after 5 seconds
        }
      }, [isPerfectScore]);

  if (showResults) {
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative bg-white rounded-lg shadow-lg p-8 max-w-md w-full mx-4 overflow-y-auto max-h-full text-center">
          {/* {isPerfectScore && (
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              className="absolute inset-0 flex items-center justify-center"
            >
             
            </motion.div>
          )} */}
                  {isPerfectScore && showConfetti && <Confetti numberOfPieces={300} gravity={0.2} />}

          {!showCorrections ? (
            <>
              <p className="text-6xl font-bold text-blue-600 mb-4">{score}%</p>
              <p className="text-lg mb-6">
                {isPerfectScore
                  ? "Congratulations! You got a perfect score! 🎉"
                  : `You got ${score}% of the questions right! Would you like to exit or check for corrections?`}
              </p>
              <div className="flex justify-around">
                <button
                  onClick={onClose}
                  className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition duration-300"
                >
                  Exit
                </button>
                <button
                  onClick={() => setShowCorrections(true)}
                  className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition duration-300"
                >
                  Check Corrections
                </button>
              </div>
            </>
          ) : (
            <>
              <h2 className="text-2xl font-bold mb-4">Corrections</h2>
              {questions.map((q, index) => (
                <div key={index} className="mb-4 border-b pb-2">
                  <p className="font-semibold">
                    Q{index + 1}: {q.question}
                  </p>
                  <p className="text-green-600">
                    Correct Answer: {q.options[q.correctAnswer]}
                  </p>
                  <p className="text-gray-700">
                    Your Answer:{" "}
                    {answers[index] !== null
                      ? q.options[answers[index]]
                      : "Skipped"}
                  </p>
                </div>
              ))}
              <button
                onClick={onClose}
                className="mt-4 bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition duration-300"
              >
                Exit
              </button>
            </>
          )}
        </div>
      </div>
    );
  }
      const currentData = questions[currentQuestion];
    
      
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
           <div className="absolute inset-0 bg-black opacity-50"></div>
      <motion.div 
className="relative bg-white rounded-lg shadow-lg p-8 max-w-md w-full mx-4"        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
      >
        <button 
        className="absolute top-3 right-3 text-red-600  text-2xl font-bold"
        onClick={onClose} 
      >
        &times;
      </button>
          <>
            <h2 className="text-xl  font-bold mb-4">{chapter} Quiz</h2>
            <AnimatePresence mode="wait">
              <motion.div
                key={currentQuestion}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                className="mb-4 text-black"
              >
                <p className="mb-2 t font-semibold">{questions[currentQuestion]?.question}</p>
                <div>
                  {questions[currentQuestion]?.options.map((option, index) => (
                    <label key={index} className="block mb-2">
                      <input
                        type="radio"
                        value={index}
                        checked={selectedOption == index}
                        onChange={() => setSelectedOption(index)}
                        className="mr-2"
                      />
                      {option}
                    </label>
                  ))}
                </div>
              </motion.div>
            </AnimatePresence>
            <div className="flex justify-between mt-4">
              <button 
                className="px-4 py-2 bg-gray-300 rounded" 
                onClick={() => handleNext(true)}
              >
                Skip
              </button>
              <div className="flex space-x-2">
              <button
          onClick={handlePrevious}
          className={`px-4 py-2 rounded ${
            currentQuestion === 0 ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"
          }`}
          disabled={currentQuestion === 0}
        >
          Previous
        </button>
              <button 
                className={`px-4 py-2 ${selectedOption !== null ? "bg-blue-500 text-black" : "bg-gray-300 text-gray-600"} rounded`} 
                onClick={() => handleNext()} 
                disabled={selectedOption === null}
              >
                {currentQuestion === questions.length - 1 ? "Finish" : "Next"}
              </button>
            </div>
            </div>
          </>
        
      </motion.div>
    </div>
  );
};

export default QuizPopup;
